import { injectIntl } from "react-intl";

import { SeoRenderer } from "../../../common/helpers/seo";

import loadableComponent from "./loadable";

export default {
    component: injectIntl(loadableComponent as any),
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        SeoRenderer({
            title: allMessage["articles.listing.title"],
            description: allMessage["articles.listing.description"],
            allMessage,
            lang,
        });
    },
};
